<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退货单号</label>
            <em class="weui-form-preview__value">{{ form.main.ir_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ir_vendname">
            <label class="weui-form-preview__label">{{customLabel.ir_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.ir_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="ir_payments">
            <label class="weui-form-preview__label">{{customLabel.ir_payments || "付款方式"}}</label>
            <span class="weui-form-preview__value">
              {{ form.main.ir_payments }}
              <span v-if="form.main.ir_currency">
                {{ form.main.ir_currency }}</span
              >
              <span v-if="form.main.ir_rate && form.main.ir_rate != 1">
                / {{ form.main.ir_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ir_date">
            <label class="weui-form-preview__label">{{customLabel.ir_date || "退货日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_date
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ird_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="ird_pucode">
            <label class="weui-form-preview__label">{{customLabel.ird_pucode || "采购单号"}}</label>
            <span class="weui-form-preview__value">{{ item.ird_pucode }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ird_vacode">
            <label class="weui-form-preview__label">{{customLabel.ird_vacode || "收料单号"}}</label>
            <span class="weui-form-preview__value">{{ item.ird_vacode }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ird_iqccode">
            <label class="weui-form-preview__label">{{customLabel.ird_iqccode || "检验单号"}}</label>
            <span class="weui-form-preview__value">{{ item.ird_iqccode }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{ item.pr_detail }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{
              item.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_spec" slot="pr_spec"> 
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{ item.pr_spec }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ird_prodcode">
            <label class="weui-form-preview__label">{{customLabel.ird_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              item.ird_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ird_iqc_type">
            <label class="weui-form-preview__label">{{customLabel.ird_iqc_type || "检验类型"}}</label>
            <span class="weui-form-preview__value">{{ item.ird_iqc_type }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ird_iqc_result">
            <label class="weui-form-preview__label">{{customLabel.ird_iqc_result || "检验结果"}}</label>
            <span class="weui-form-preview__value">{{ item.ird_iqc_result }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ird_return_qty">
            <label class="weui-form-preview__label">{{customLabel.ird_return_qty || "退货数量"}}</label>
            <span class="weui-form-preview__value">{{ item.ird_return_qty }} {{ item.pr_unit }}</span>
          </div>
          </custom-layout>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="form.main.ir_status === '已审核'">
      <express class="weui-dialog__btn weui-dialog__btn_primary" :bizType="'PurcIqcReturn'" :bizCode="form.main.ird_ircode" :bizId="form.main.id"></express>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Express from "@/components/button/Express.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Express
  },
  data() {
    return {
      baseUrl: "/api/storage/purciqcreturn",
      caller:'PurcIqcReturn',
      xtype:'stock-purcIqcReturn-formpanel'
    };
  },
};
</script>